import { IFormFieldOptions } from "@/interfaces";
import { Select } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { useEffect, useState } from "react";

interface IProps {
  value: string;
  options: IFormFieldOptions;
  showSearch?: boolean;
  disabled?: boolean;
  onChange(data: string): void;
}

export const TableSelect = ({
  value,
  options,
  showSearch = false,
  disabled = false,
  onChange,
}: IProps) => {
  const [convertedOptions, setConvertedOptions] = useState<DefaultOptionType[]>(
    []
  );

  useEffect(() => {
    if (!options) return;
    setConvertedOptions(
      Object.keys(options).map((key) => ({
        value: key,
        label: options[key].fallback,
      }))
    );
  }, [options]);

  return (
    <Select
      data-test-id="table-select"
      showSearch={showSearch}
      options={convertedOptions}
      value={value ?? undefined}
      filterOption={(input: string, option?: DefaultOptionType): boolean =>
        ((option?.label as string) ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onChange={(data): void => onChange(data)}
      disabled={disabled}
    />
  );
};
